// Función para establecer una cookie
function setCookie(name, value, minutes) {
    const date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${date.toUTCString()};path=/`;
}

// Función para obtener una cookie
function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
            return decodeURIComponent(cookie.substring(name.length + 1));
        }
    }
    return null;
}

// Función para generar un número aleatorio entre un rango
function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Función para seleccionar aleatoriamente una frase con el número incluido
function getRandomPhrase(number) {
    const phrases = [
        `<strong>${number} personas</strong> agregaron este producto a su carrito en la ultima hora.`,
        `<strong>${number} personas</strong> agregaron este producto a su carrito en la ultima hora.`,
        `<strong>${number} personas</strong> agregaron este producto a su carrito en la ultima hora.`,
        `<strong>${number} personas</strong> agregaron este producto a su carrito en la ultima hora.`,
        `<strong>${number} personas</strong> agregaron este producto a su carrito en la ultima hora.`,
        `<strong>${number} personas</strong> agregaron este producto a su carrito en la ultima hora.`
    ];
    return phrases[Math.floor(Math.random() * phrases.length)];
}

// Función principal para manejar la frase generada
function handleRandomPhrase() {
    const cookieName = "incentiveText";
    const timestampName = "timestamp";

    const savedPhrase = getCookie(cookieName);
    const savedTimestamp = getCookie(timestampName);

    const now = new Date().getTime();
    const tenMinutes = 10 * 60 * 1000;

    if (savedPhrase && savedTimestamp && now - parseInt(savedTimestamp) < tenMinutes) {
        // Si la cookie existe y no han pasado 10 minutos, usa la frase guardada
        return savedPhrase;
    } else {
        // Si no hay frase guardada o ya pasaron 10 minutos, genera una nueva
        const randomNumber = getRandomNumber(8, 16);
        const newPhrase = getRandomPhrase(randomNumber);
        setCookie(cookieName, newPhrase, 10); // Guardar frase por 10 minutos
        setCookie(timestampName, now, 10);   // Guardar timestamp por 10 minutos
        return newPhrase;
    }
}

// Ejecución
document.addEventListener('DOMContentLoaded', function () {
    const randomPhrase = handleRandomPhrase();
    console.log(`Frase generada: ${randomPhrase}`); // Para depuración
    document.getElementById("incentive-text").innerHTML = randomPhrase; // Reemplaza el contenido del HTML
});
